module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0064.jpg?v=036e0467";